<template>
	<li class="list-group-item list-group-item-dark">
		<b-card>
      <p class="card-text hoverable" @click="setVisibility(layer.$layer)">
         <f-icon :icon="icon"></f-icon>
         {{ layer.legendName }}
      </p>
			<legend-item-tools :layer="layer" v-show="this.showTools" />
		</b-card>
	</li>
</template>

<script>
import LegendItemTools from '../Legend/ItemTools.vue'

const components = {
	LegendItemTools
}
const methods = {
  setVisibility (layer) {
    let visible = layer.getVisible()
    layer.setVisible(!visible)
    this.icon = !visible ? this.visibleIcon : this.notVisibleIcon
    this.showTools = !visible
  }
}

export default {

  name: 'Item',
  methods,
  components,
  props: {
  	// ol BaseLayer
  	layer: {
  		type: Object,
  		required: true
  	},
    visible: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      icon: 'eye',
      visibleIcon: 'eye',
      notVisibleIcon: 'eye-slash',
      showTools: this.visible
    }
  },
  mounted () {
    this.icon = this.visible ? this.visibleIcon : this.notVisibleIcon;
  }
}
</script>

<style lang="css" scoped>
  .hoverable {
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// resources/js/map/MapComponents/Legend/Item.vue